export const errorMessages = {
    REQUIRED_FIELD: "This field is required",
    INVALID_PHONE_NUMBER: "Invalid phone number.Digits only (0–9), max 15 characters",
    PHONE_NUMBER_LENGTH: "Phone number must be between 7 and 15 characters",
    INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
    INVALID_EMAIL: "Please enter a valid email address",
    INVALID_PASSWORD:
      "Password must be at least 6 characters.",
    PASSWORD_MISMATCH: "Passwords do not match",
    ERROR_OCCURRED: "An error occurred",
    UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
    COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
    INVALID_OPTION: "Invalid Option",
    SOMETHING_WENT_WRONG: "Something Went Wrong",
    FAILED_RESET_PASSWORD: "Failed to Reset Password",
    LOGIN_FAILED: "Login Failed",
    FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
    FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
    INVALID_NUMBER: "Invalid Number",
    INVALID_OPTION: "Invalid Option",
    INVALID_ID_NUMBER:  "Invalid ID format.", // Use GHA-XXXXXXXXX-X.",
    INVALID_DATE: "Invalid Date",
    INVALID_TIME: "Invalid Time",
  INVALID_POSITIVE_DECIMAL: "Invalid decimal number. Must be a positive number with up to 2 decimal places.",
  };